import menu from "./lib/menu";
import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
import impacto from "./colabora/impacto";
import provincias from "./colabora/provincias";
import cantidades from "./colabora/cantidades";
import preguntasFrecuentes from "./colabora/preguntas-frecuentes";
import telefonos from "./colabora/telefonos";
import trivial from "./colabora/trivial";

import '../sass/app.scss';

const ajustaVw = () => {
    document.documentElement.style.setProperty('--vw', `${document.documentElement.clientWidth}px`);
};

export interface IDataLayer {
    push: Function
}

const dataLayer = (window as any).dataLayer as IDataLayer;

addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
menu();

impacto();

formulario('form:not(.sin-ajax)', {
    dataLayer,
    ocultarEtiquetas: true,
    onInicializado: () => {
        cantidades();
        provincias();
    }
});

preguntasFrecuentes();
telefonos();
trivial();

animadoAlAparecer('.animado');